import React, { useState } from 'react';
import styled from 'styled-components';
import { FaHome, FaUser, FaUsers, FaMoneyBill, FaTshirt, FaUserSecret, FaUserCheck, FaTasks } from 'react-icons/fa';

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background-color: #111622;
  width: ${({ isOpen }) => (isOpen ? '240px' : '60px')};
  transition: width 0.3s ease;
  display: none;
  padding: 20px 10px;
  box-shadow: 0 3px 6px #00000029;
  z-index: 1000;

  svg {
      color: ${({ isOpen}) => (isOpen ? '#87e20f' : '#fff')};
      width: 24px;
      height: 24px;
      transition: margin 0.3s ease;
      margin-right: ${({ isOpen }) => (isOpen ? '15px' : '0')};
  }

  @media (min-width: 1180px) {
    display: flex;
    flex-direction: column;
  }
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  margin-bottom: 30px;
  align-self: center;
`;

const NavItem = styled.a`
  display: flex;
  align-items: center;
  color: #ffae42;
  text-decoration: none;
  font-size: 16px;
  margin-bottom: 30px;
  white-space: nowrap;
  width: 100%;
  justify-content: ${({ isOpen }) => (isOpen ? 'flex-start' : 'center')};
  transition: all 0.3s ease;
  padding-left: ${({ isOpen }) => (isOpen ? '20px' : '0')};
`;

const Label = styled.span`
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.2s ease;
  transition-delay: ${({ show }) => (show ? '0.3s' : '0s')};
  width: ${({ show }) => (show ? 'fit-content' : '0')} ;
  color: #fff;
  font-size: 18px;
  a {
    color: #fff;
  }
`;

// MOBILE

const BottomMenu = styled.nav`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #111622;
  padding: 12px 0;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  box-shadow: 0px -3px 6px #00000029;
  max-height: 60px;
  white-space: nowrap;
  overflow-x: auto;
  z-index: 3;

  &::-webkit-scrollbar,
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumbr {
    background: #87e20f;
    height: 2px;
    width: 2px;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-track{
    background: #fff;
    border-radius: 2px;
  }

  @media (min-width: 1180px) {
    display: none;
  }
`;

const MenuItem = styled.a`
  background: none;
  border: none;
  color: white;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  width: 28.5%;

  svg {
    font-size: 20px;
    margin-bottom: 4px;
  }

  &:hover {
    color: #00ff88;
  }
`;

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Sidebar isOpen={isOpen}>
        <ToggleButton onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? '✖' : '☰'}
        </ToggleButton>

        <NavItem href="/home" isOpen={isOpen}>
            <FaHome isOpen={isOpen} />
            <Label show={isOpen}>
              Home
            </Label>
        </NavItem>

        <NavItem href="/confirm" isOpen={isOpen}>
            <FaTasks isOpen={isOpen} />
            <Label show={isOpen}>Confirmar presença</Label>
        </NavItem>

        <NavItem href="/generate-teams" isOpen={isOpen}>
            <FaUsers isOpen={isOpen} />
            <Label show={isOpen}>Gerar Times</Label>
        </NavItem>

        <NavItem href="/members" isOpen={isOpen}>
            <FaUserCheck isOpen={isOpen} />
            <Label show={isOpen}>
            Mensalistas
          </Label>
        </NavItem>

        <NavItem href="/finance" isOpen={isOpen}>
            <FaMoneyBill isOpen={isOpen} />
            <Label show={isOpen}>Financeiro</Label>
        </NavItem>

        <NavItem href="/vests" isOpen={isOpen}>
          <FaTshirt isOpen={isOpen} />
          <Label show={isOpen}>Coletes</Label>
        </NavItem>

        <NavItem href="/admin" isOpen={isOpen}>
          <FaUserSecret  isOpen={isOpen} />
          <Label show={isOpen}>Administrador</Label>
        </NavItem>

        <NavItem href="/my-account" isOpen={isOpen}>
            <FaUser isOpen={isOpen} />
            <Label show={isOpen}>Minha Conta</Label>
        </NavItem>
      </Sidebar>

      <BottomMenu>
        <MenuItem href='/home'>
          <FaHome /> Home
        </MenuItem>
        <MenuItem href='/confirm'>
          <FaTasks /> Confirmar presença
        </MenuItem>
        <MenuItem href='/generate-teams'>
          <FaUsers /> Gerar Times
        </MenuItem>
        <MenuItem href='/members'>
          <FaUserCheck /> Mensalistas
        </MenuItem>
        <MenuItem href='/finance'>
          <FaMoneyBill /> Financeiro
        </MenuItem>
        <MenuItem href='/vests'>
          <FaTshirt /> Coletes
        </MenuItem>
        <MenuItem href='/admin'>
          <FaUserSecret /> Admin
        </MenuItem>
        <MenuItem href='/my-account'>
          <FaUser /> Conta
        </MenuItem>
        
      </BottomMenu>
    </>
  );
}

export default Header;
